import styled from 'styled-components';

export const LoadingImage = styled.img`
  margin: 80px auto;
  display: block;
`;



// WEBPACK FOOTER //
// ./src/components/Loading/style.js